import React from "react";
import { ArrayPath, FieldValues } from "react-hook-form";

import {
    BaseFieldArray,
    BaseFieldArrayChildProps
} from "../BaseFieldArray/baseFieldArray.component";
import { FormArrayValuesExploded } from "../formField.types";

export type MultiTextFieldChildrenProps<T extends FieldValues> =
    BaseFieldArrayChildProps<T> & {
        disabled?: boolean;
    };

type MultiTextFieldProperties<T extends FieldValues> = {
    disabled?: boolean;
    children: (props: MultiTextFieldChildrenProps<T>) => React.ReactNode;
};

export type MultiTextFieldProps<T extends FieldValues> =
    FormArrayValuesExploded<T> & MultiTextFieldProperties<T>;

const MultiTextField = <T extends FieldValues>({
    name,
    label,
    microCopy,
    required,
    disabled,
    children
}: MultiTextFieldProps<T>) => {
    return (
        <BaseFieldArray<T, ArrayPath<T>>
            name={name}
            label={label}
            microCopy={microCopy}
            required={required}
        >
            {(props) => children({ ...props, disabled })}
        </BaseFieldArray>
    );
};

export { MultiTextField };
